import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubstituteParentChild = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.42487 4.32673C8.12141 4.63018 8.12141 5.12088 8.42487 5.42111C8.5567 5.55154 8.72388 5.62592 8.89542 5.64344C8.94823 5.64884 9.00145 5.64885 9.05419 5.64344C9.22445 5.626 9.38961 5.55215 9.51925 5.42111L11.2948 3.64556L11.154 5.64344L11.154 14.6895C11.154 15.1188 11.6435 15.4642 12.0728 15.4642C12.5022 15.4642 13.1251 15.1188 13.1251 14.6895L13.1439 5.64344L12.8476 3.64556L14.6231 5.42111C14.7518 5.54977 14.9141 5.62388 15.0813 5.64344C15.3085 5.67001 15.5446 5.5959 15.7175 5.42111C16.0178 5.11765 16.021 4.62696 15.7175 4.32673L12.6216 1.22759C12.3182 0.924136 11.8275 0.924136 11.5272 1.22759L8.4281 4.32673L8.42487 4.32673Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2948 3.64556L9.51925 5.42111C9.38961 5.55215 9.22445 5.626 9.05419 5.64344L11.154 5.64344L11.2948 3.64556Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8476 3.64556L13.1439 5.64344L15.0813 5.64344C14.9141 5.62388 14.7518 5.54977 14.6231 5.42111L12.8476 3.64556Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.7163 12.1381C8.01976 11.8347 8.01976 11.344 7.7163 11.0437C7.58447 10.9133 7.4173 10.8389 7.24576 10.8214C7.19295 10.816 7.13972 10.816 7.08699 10.8214C6.91672 10.8388 6.75157 10.9127 6.62192 11.0437L4.84638 12.8193L4.9872 10.8214L4.9872 1.77538C4.9872 1.34602 4.49772 1.0006 4.06836 1.0006C3.639 1.0006 3.01607 1.34602 3.01607 1.77538L2.99727 10.8214L3.29358 12.8193L1.51803 11.0437C1.38937 10.9151 1.22704 10.841 1.05985 10.8214C0.832709 10.7948 0.596582 10.8689 0.423649 11.0437C0.123421 11.3472 0.120192 11.8379 0.423649 12.1381L3.51956 15.2373C3.82301 15.5407 4.31371 15.5407 4.61394 15.2373L7.71308 12.1381L7.7163 12.1381Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.84638 12.8193L6.62192 11.0437C6.75157 10.9127 6.91672 10.8388 7.08699 10.8214L4.9872 10.8214L4.84638 12.8193Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.29358 12.8193L2.99727 10.8214L1.05985 10.8214C1.22704 10.841 1.38937 10.9151 1.51803 11.0437L3.29358 12.8193Z",
			fill: "#FF6B00"
		})
	]
});
export default SvgSubstituteParentChild;
